
import CreateEditCategoryDialog from "../dialogs/create-edit-category-dialog.vue";
import CreateComboDialog from "../dialogs/menu-create-combo-dialog.vue";
import CreateEditAddonDialog from "../dialogs/create-edit-addon-dialog.vue";
import ResponsiveDialog from "../dialogs/responsive-dialog.vue";
export default {
  components: {
    ResponsiveDialog,
    CreateEditCategoryDialog,
    CreateComboDialog,
    CreateEditAddonDialog
  },
  props: {
    dialog: false,
    persistent: false,
    dialogWidth: "500"
  },
  data: () => {
    return {
      addNewList: [
        { id: "add-new-item", label: "Add New Item" },
        { id: "create-new-category", label: "Create New Category" },
        { id: "create-combo", label: "Create Combo" },
        { id: "create-addon", label: "Create Add-on" }
      ],
      showCategoryDialog: false,
      showCreateAddonDialog: false,
      showCreateComboDialog: false,
      selectedCategory: {}
    };
  },
  methods: {
    handleAddNew(item) {
      switch (item.id) {
        case "add-new-item":
          this.$router.push("/menu/new/item");
          break;
        case "create-new-category":
          this.selectedCategory = {};
          this.showCategoryDialog = true;
          break;
        case "create-combo":
          this.showCreateComboDialog = true;
          break;
        case "create-addon":
          this.showCreateAddonDialog = true;
          break;
      }
    }
  }
};
